// teido_store.js
import axios from "axios";

const state = {
    // Здесь могут быть состояния для хранения ответов API
    teidoResponse: null,
    loading: false,
    error: null
};

const getters = {
    // Геттеры для доступа к состояниям
    getTeidoResponse: state => state.teidoResponse,
    isLoading: state => state.loading,
    getError: state => state.error
};

const mutations = {
    // Мутации для изменения состояний
    SET_TEIDO_RESPONSE(state, response) {
        state.teidoResponse = response;
    },
    SET_LOADING(state, status) {
        state.loading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    getAxios: async ({commit}, payload) => {
        return axios.create({
            baseURL: process.env.VUE_APP_NEW_API_URL,
            headers: {
                Accept: 'application/json',
                'X-Lang-Header': payload.lang,
                Authorization: payload.auth,
            },
        });
    },

    prepareYoungTreeAsync: async ({dispatch, commit}, {payload, headers}) => {
        const myAxios = await dispatch('getAxios', headers);
        return await myAxios.post('/api/services/payment/pending-tree', payload)
            .then(({data}) => {
                return {
                    isSuccess: true,
                    data: data.data,
                }
            })
            .catch(e => {
                return {
                    isSuccess: false,
                    exception: e.response && e.response.data ? e.response.data : e
                }
            });
    },

    // Обновленный метод с использованием corsproxy.io без опциональной цепочки
    initTeidoAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        // Создаем URL через CORS прокси

        const fullUrl = 'http://localhost:3000/teido/wp3dsinit';

        try {
            // Создаем специальный экземпляр axios для запроса через прокси
            const response = await axios({
                method: 'post',
                url: fullUrl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    // Передаем только необходимые заголовки
                    // Некоторые заголовки могут не пройти через CORS прокси
                }
            });

            commit('SET_TEIDO_RESPONSE', response.data);
            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data,
            };
        } catch (error) {
            console.error('Teido API error:', error);
            commit('SET_ERROR', error.message || 'Error connecting to payment service');
            commit('SET_LOADING', false);

            // Избегаем использования опциональной цепочки
            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message || 'Failed to connect to payment service',
                    data: responseData
                }
            };
        }
    },

    // Метод для 3DS аутентификации (тоже через прокси)
    teidoAuth3dsAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);

        const fullUrl = 'http://localhost:3000/teido/wp3dsinit';
        const req = {
            "co": "al",
                "product": "1000",
                "productdescription": "AI usage",
                "usdc": "",
                "pool": "",
                "cardholder": "John Smith",
                "customer": "AY3HP8K3",
                "cc": "5168752015853008",
                "card_exp": "05/25",
                "cvv": "832",
                "amount": "1",
                "currency": "USD"
        }
        try {
            const response = await axios({
                method: 'post',
                url: fullUrl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data
            };
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);

            // Избегаем использования опциональной цепочки
            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message,
                    data: responseData
                }
            };
        }
    },

    // Метод для верификации 3DS
    teidoVerify3dsAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);

        const corsProxyUrl = 'https://corsproxy.io/?key=9bb96d54&url=';
        const targetUrl = 'https://pay.teido.io/wp3dsverify/';
        const fullUrl = corsProxyUrl + encodeURIComponent(targetUrl);

        try {
            const response = await axios({
                method: 'post',
                url: fullUrl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data
            };
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);

            // Избегаем использования опциональной цепочки
            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message,
                    data: responseData
                }
            };
        }
    },

    // Метод для выполнения платежа
    teidoPayAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);

        const corsProxyUrl = 'https://corsproxy.io/?key=9bb96d54&url=';
        const targetUrl = 'https://pay.teido.io/wppay/';
        const fullUrl = corsProxyUrl + encodeURIComponent(targetUrl);

        try {
            const response = await axios({
                method: 'post',
                url: fullUrl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data
            };
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);

            // Избегаем использования опциональной цепочки
            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message,
                    data: responseData
                }
            };
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};